var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0833 30.5833V8.70829C13.0833 8.32152 12.9297 7.95059 12.6562 7.6771C12.3827 7.4036 12.0118 7.24996 11.625 7.24996H4.33334C3.55979 7.24996 2.81792 7.55725 2.27094 8.10423C1.72396 8.65121 1.41667 9.39308 1.41667 10.1666V27.6666C1.41667 28.4402 1.72396 29.182 2.27094 29.729C2.81792 30.276 3.55979 30.5833 4.33334 30.5833H21.8333C22.6069 30.5833 23.3488 30.276 23.8957 29.729C24.4427 29.182 24.75 28.4402 24.75 27.6666V20.375C24.75 19.9882 24.5964 19.6173 24.3229 19.3438C24.0494 19.0703 23.6784 18.9166 23.2917 18.9166H1.41667M20.375 1.41663H29.125C29.9304 1.41663 30.5833 2.06954 30.5833 2.87496V11.625C30.5833 12.4304 29.9304 13.0833 29.125 13.0833H20.375C19.5696 13.0833 18.9167 12.4304 18.9167 11.625V2.87496C18.9167 2.06954 19.5696 1.41663 20.375 1.41663Z",
    stroke: "#0071E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.1cf3ff03800774d667e4aded6b800a40.svg";
export { ForwardRef as ReactComponent };